import { useSyncExternalStore } from 'react';

export type ColorScheme = 'light' | 'dark';

const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';

/** jsdom and older browsers have no `matchMedia`; both should read as light, not crash. */
function mediaQuery(): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(DARK_SCHEME_QUERY);
}

function subscribe(onChange: () => void): () => void {
  const media = mediaQuery();
  if (media === null) return () => undefined;

  media.addEventListener('change', onChange);
  return () => {
    media.removeEventListener('change', onChange);
  };
}

function getSnapshot(): ColorScheme {
  return mediaQuery()?.matches === true ? 'dark' : 'light';
}

/**
 * The operating system's light/dark setting, kept current as the user changes it.
 *
 * Subscribed rather than read once so that someone on the "match system" theme sees the
 * app follow their machine at dusk without reloading.
 */
export function useSystemColorScheme(): ColorScheme {
  return useSyncExternalStore(subscribe, getSnapshot, () => 'light');
}
